import { ComponentStyles, defaultComponentStyles } from './componentStyles'
import { spacing } from './spacing'

export const auroraComponentStyles: ComponentStyles = {
  ...defaultComponentStyles,
  integratedBenefitsExplorer: {
    showHeader: true,
    showMinimizedBannerDesign: false,
    showBenefitsAndCoverageSection: true,
  },
  integratedBenefitsEntryCard: {
    showBorder: false,
    paddingHorizontal: spacing['16px'],
    divider: {
      height: '1px',
    },
    shouldShowArrow: false,
    allowBackgroundColorOverride: false,
  },
}
